// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__eP2Vh","productName":"Table_productName__22X9R"};